import type {Content} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {DefaultGridWithFeature} from './DefaultGridWithFeature'

export type GridWithFeatureProps = SliceComponentProps<Content.GridWithFeatureSlice>

const GridWithFeature = ({
  slice,
  context: {pageUid},
}: GridWithFeatureProps & {context: Context}): JSX.Element | null => (
  <DefaultGridWithFeature
    backgroundColor={slice.primary.background_color}
    showFeature={slice.primary.show_feature ?? false}
    featurePosition={slice.primary.feature_position === 'Bottom' ? 'Bottom' : 'Top'}
    featureTitle={isFilled.keyText(slice.primary.feature_title) ? slice.primary.feature_title : ''}
    featureDescription={isFilled.keyText(slice.primary.feature_description) ? slice.primary.feature_description : ''}
    featureImage={slice.primary.feature_image}
    featureNote={isFilled.keyText(slice.primary.feature_note) ? slice.primary.feature_note : ''}
    featureButtonLabel={isFilled.keyText(slice.primary.feature_button_label) ? slice.primary.feature_button_label : ''}
    featureButtonLink={slice.primary.feature_button_link}
    pageUid={pageUid ?? ''}
    paddingTop={slice.primary.padding_top}
    paddingBottom={slice.primary.padding_bottom}
    cards={slice.items.map((item) => ({
      title: isFilled.keyText(item.title) ? item.title : '',
      description: isFilled.keyText(item.description) ? item.description : '',
      image: item.image,
      hasButton: isFilled.link(item.button),
      buttonLink: item.button,
    }))}
  />
)

export default GridWithFeature
